// extracted by mini-css-extract-plugin
export default {"clientInfo":"styles_clientInfo__KLnMk","infoText":"styles_infoText__IXUlZ","circleLinksWrap":"styles_circleLinksWrap__yYZC8"};